{
  "account": {
    "title": "Moje konto",
    "list": {
      "title": "Konta",
      "description": "Lista faktur powiązanych kont"
    },
    "form": {
      "name": {
        "title": "Nazwa",
        "description": "Nazwa Twojego konta"
      },
      "password": {
        "title": "Hasło",
        "description": "Ustaw nowe hasło dla swojego konta; pozostaw puste, aby zachować bieżące hasło"
      },
      "emailPreferences": {
        "title": "Preferencje e-mail",
        "description": "Wybierz rodzaje powiadomień e-mail"
      }
    },
    "billing": "Dane rozliczeniowe",
    "subscriptions": "Subskrypcje",
    "manageSubscription": "Zarządzaj subskrypcją",
    "popup": {
      "cancel": "Czy na pewno chcesz anulować subskrypcję?<br/>Twoja strona będzie tłumaczona do końca bieżącego okresu rozliczeniowego. Po tym czasie tłumaczenie zostanie wyłączone.<br/>Zwracamy uwagę, że nie przysługuje zwrot za niewykorzystany okres.",
      "downgrade": "Czy na pewno chcesz obniżyć plan? Zmiana stanie się skuteczna natychmiast.<br/>Zwracamy uwagę, że nie przysługuje zwrot za pozostały czas bieżącego cyklu rozliczeniowego.<br/>Nowa cena planu zostanie zastosowana od następnego cyklu rozliczeniowego.",
      "default": "Czy na pewno chcesz zmienić swój plan?",
      "resume": "Czy na pewno chcesz wznowić subskrypcję?"
    }
  },
  "ai_translation": {
    "header": "Tłumaczenie AI",
    "plan": {
      "header": "Cennik tłumaczenia AI",
      "used": "Wykorzystałeś {words_used} / {words_allowed} przetłumaczonych słów w swoich kredytach AI.",
      "remaining": "Dostępne kredyty AI:",
      "words": "słów",
      "add_more_credits": "Dodaj więcej kredytów AI",
      "details": {
        "idiomatic_expressions": "Idiomy i wyrażenia techniczne",
        "background_translation": "Tłumaczenia w tle",
        "best_website": "Strony wymagające idealnej jakości tłumaczenia",
        "page_context": "Kontekst strony i całej witryny",
        "perfect_quality": "Perfekcyjna jakość w przystępnej cenie",
        "no_recurring": "Brak płatności cyklicznych, przedpłacony limit",
        "save_40": "Oszczędzaj 40% w porównaniu z planem 20 USD",
        "save_50": "Oszczędzaj 50% w porównaniu z planem 20 USD"
      },
      "quota": "{estimated_words} słów ~ {estimated_pages} stron"
    },
    "settings": {
      "banner": {
        "title": "Linguise Tłumaczenie AI",
        "intro": "Linguise z przyjemnością prezentuje Linguise Tłumaczenie AI – nową, premium funkcję wykorzystującą LLM AI (najnowsze modele Llama zoptymalizowane pod tłumaczenia). Stworzona dla stron wymagających perfekcyjnej dokładności, bierze pod uwagę kontekst zarówno strony, jak i całej witryny, zapewniając niezrównane rezultaty. Oferuj klientom szczytową jakość tłumaczenia, gwarantując, że ich przekaz doskonale brzmi w każdym języku.",
        "button": "Uaktualnij teraz"
      },
      "alert": {
        "description": "Funkcja ta nie jest objęta Twoim obecnym planem i wymaga osobnego zakupu.\nAktywuj ten dodatek, aby odblokować wszystkie opcje wymienione poniżej."
      },
      "languages": {
        "title": "Zastosuj tłumaczenie AI do języków",
        "description": "Wybierz konkretny język, w którym ma być stosowane tłumaczenie AI"
      },
      "button": {
        "save": "Zapisz ustawienia"
      },
      "form": {
        "advanced": {
          "title": "Zaawansowane instrukcje AI",
          "description": "Zaawansowane instrukcje AI"
        },
        "enable_mode": {
          "title": "WŁĄCZ TŁUMACZENIE AI",
          "description": "Wybierz sposób włączania tłumaczenia AI.\n„Tylko reguły” zastosuj poniższe reguły.\n„Tylko edytor na żywo” pozwala włączać tłumaczenie strona po stronie z poziomu widoku edytora.\n„Reguły i edytor” używa obu funkcji.",
          "disabled": "Wyłączone",
          "rules": "Tylko reguły",
          "live_editor": "Tylko edytor na żywo",
          "all": "Reguły i edytor"
        },
        "rule_application": {
          "description": "Zastosuj tłumaczenie AI do treści statycznych, dynamicznych lub obu",
          "title": "Zastosuj do treści",
          "all": "Wszystkie treści",
          "static": "Treść statyczna",
          "dynamic": "Treść dynamiczna"
        },
        "website_topic": {
          "title": "Temat witryny",
          "placeholder": "Restauracja sushi...",
          "description": "Określ temat swojej witryny dla lepszej jakości tłumaczenia (np. prawo, restauracja sushi, sklep z częściami rowerowymi…)\nWpisz temat witryny w języku angielskim."
        },
        "apply_to_urls": {
          "title": "Zastosuj do adresów URL",
          "description": "Wybierz konkretne adresy URL, na których ma być stosowane tłumaczenie AI",
          "all_urls": "Wszystkie adresy URL",
          "selected_urls": "Wybrane adresy URL",
          "label": "Adres URL do zastosowania",
          "placeholder": "Adres URL do zastosowania",
          "wildcard": "Dowolny znak",
          "regex": "Wyrażenie regularne",
          "add": "Dodaj nowy",
          "expression": "Typ wyrażenia"
        },
        "apply_languages": {
          "title": "Zastosuj do języków",
          "description": "Wybierz konkretny język, w którym ma być stosowane tłumaczenie AI",
          "all_languages": "Wszystkie języki",
          "selected_languages": "Wybrane języki",
          "placeholder": "Wybierz języki...",
          "feedback": "Musisz wybrać język"
        },
        "formality": {
          "title": "Stopień formalności",
          "description": "Określ poziom formalności w tłumaczeniach – może być istotny dla odbiorców i kontekstu.\n„Neutralny” zachowa pierwotną formalność treści.\n„Formalny” przeznaczony dla treści profesjonalnych, biznesowych czy prawnych (czyli używający formalnych zaimków np. „usted” w hiszpańskim).\n„Nieformalny” dla treści swobodnych, konwersacyjnych (czyli używający np. „tú” w hiszpańskim).",
          "neutral": "Neutralny",
          "formal": "Formalny",
          "informal": "Nieformalny"
        },
        "sentence_structure": {
          "classic": "Klasyczna",
          "short": "Krótkie, dynamiczne zdania",
          "detailed": "Szczegółowe i objaśniające zdania",
          "title": "Budowa zdań",
          "description": "Określ preferowany styl pisania."
        },
        "content_purpose": {
          "marketing": "Marketingowy/promocyjny (przekonujący, angażujący ton)",
          "technical": "Techniczny/instruktażowy (jasny, precyzyjny, ukierunkowany na działanie)",
          "support": "Wsparcie klienta (empatyczny, pomocny, uspokajający)",
          "legal": "Prawny/zgodność (precyzyjny, formalny, jednoznaczny)",
          "educational": "Edukacyjny (jasny, uporządkowany, dostępny)",
          "other": "Inny (w języku angielskim)",
          "title": "Cel treści",
          "description": "Określ funkcjonalny cel treści poddawanej tłumaczeniu.",
          "other_placeholder": "Opisz cel..."
        },
        "target_audience": {
          "title": "Docelowi odbiorcy",
          "description": "Określenie planowanej grupy odbiorców przetłumaczonej treści (w języku angielskim).",
          "placeholder": "np. rodzice hiszpańskojęzyczni, urzędnicy ds. prywatności w UE"
        },
        "override_default_translations": {
          "title": "Zastąp domyślne tłumaczenie",
          "description": "Jeśli ustawione na TAK, opcja ta wymusi tłumaczenie treści za pomocą AI (Linguise AI), nawet jeśli została już przetłumaczona przez domyślny model tłumaczenia Cloud AI."
        },
        "force_replace_before": {
          "title": "Wymuś ponowne tłumaczenie przez AI",
          "description": "Przetłumacz ponownie przez AI każdą treść, której tłumaczenie AI powstało przed wybraną datą — na przykład treść przetłumaczoną starszym modelem. Ponowne tłumaczenie nastąpi podczas następnej wizyty na stronach objętych regułami i wykorzysta kredyty AI.",
          "before_date": "Przed datą"
        },
        "model": {
          "current": "Obecny",
          "title": "Model",
          "description": "Wybierz model tłumaczenia LLM, którego chcesz użyć",
          "load_error": "Nie można załadować dostępnych modeli. Spróbuj ponownie później.",
          "thinking_warning": "Ten model używa wysokiego poziomu rozumowania (\"myślenie\") i zużyje znacznie więcej tokenów na tłumaczenie."
        },
        "override_manual_and_selected": {
          "no_default": "Nie (domyślnie)",
          "title": "Nadpisuj tłumaczenia ręczne i wybrane",
          "description": "Domyślnie tłumaczenie edytowane ręcznie zawsze pozostaje na Twojej stronie, nawet po wygenerowaniu ulepszonego tłumaczenia AI. Ustaw TAK, aby zamiast niego wyświetlać ulepszone tłumaczenie AI. Twoje tłumaczenia ręczne są zachowane i w każdej chwili możesz do nich wrócić. Dotyczy to również ponownego tłumaczenia stron w celu uzyskania nowych tłumaczeń; automatycznie zostanie użyte najnowsze tłumaczenie."
        }
      },
      "message": {
        "save_success": "Z obecnie przetłumaczonych treści liczba stron, które zostaną ulepszone tłumaczeniem AI, to około {{ai_affected_urls}}.",
        "save_success_only": "Ustawienia zostały pomyślnie zapisane."
      }
    },
    "pricing": {
      "plan": {
        "title": "Zamów limit tłumaczenia AI",
        "buy_button": "KUP PAKIET TŁUMACZENIA AI"
      },
      "modal": {
        "title": "Potwierdź zmianę planu",
        "description": "Czy na pewno chcesz zmienić swój plan tłumaczenia AI?",
        "button_cancel": "Anuluj",
        "button_confirm": "Potwierdź",
        "loading": "Proszę czekać...",
        "amount": "Kwota",
        "credit": "Kredyt",
        "total_due": "Do zapłaty"
      },
      "comparison": {
        "title": "Tłumaczenie AI Google Cloud\nvs tłumaczenie AI Linguise",
        "list": {
          "0": {
            "google": "Szybkie i niezawodne tłumaczenia",
            "linguise": "Obsługa idiomów i terminów technicznych"
          },
          "1": {
            "google": "Natychmiastowe tłumaczenia wszystkich stron",
            "linguise": "Tłumaczenia generowane w tle"
          },
          "2": {
            "google": "Najlepsza jakość, niska cena",
            "linguise": "Perfekcyjna jakość, przystępna cena"
          },
          "3": {
            "google": "Najlepszy dla dużych stron lub małego budżetu",
            "linguise": "Najlepszy dla stron wymagających perfekcyjnego tłumaczenia"
          },
          "4": {
            "google": "Kontekst strony dla tłumaczenia",
            "linguise": "Kontekst strony i całej witryny dla tłumaczenia"
          }
        }
      },
      "botom_banner": {
        "title": "Odkryj bezprecedensową dokładność tłumaczenia dzięki",
        "sub_title": "Nowej usłudze Linguise AI Translation",
        "description": "Linguise ulepsza swoje automatyczne tłumaczenia dzięki wprowadzeniu usługi Linguise AI Translation – potężnej nowej opcji wykorzystującej najnowsze modele LLM do tłumaczenia (optymalizowane modele Llama). To uzupełnienie zapewnia deweloperom stron i agencjom webowym jeszcze wyższy poziom jakości tłumaczenia, idealny dla projektów, w których liczy się perfekcja. Linguise AI Translation uzupełnia istniejące tłumaczenia Google Cloud AI, oferując większą elastyczność i precyzję."
      }
    },
    "success": {
      "tab_title": "Dziękujemy za zakup planu AI Translation!",
      "title": "Dziękujemy za zakup planu AI Translation!",
      "subtitle": "Twój plan AI Translation został pomyślnie zakupiony!",
      "message": "Możesz zarządzać swoim planem AI Translation na stronie ustawień AI Translation.",
      "home": "Zarządzaj AI Translation"
    }
  },
  "billing": {
    "form": {
      "name": {
        "title": "Nazwa",
        "description": "Nazwa konta rozliczeniowego"
      },
      "phone": {
        "title": "Telefon",
        "description": "Telefon do konta rozliczeniowego"
      },
      "email": {
        "title": "E-mail",
        "description": "E-mail do konta rozliczeniowego"
      },
      "address": {
        "title": "Adres",
        "description": "Adres konta rozliczeniowego",
        "city": "Miasto",
        "country": "Kraj",
        "address1": "Adres 1",
        "address2": "Adres 2",
        "postal": "Kod pocztowy",
        "state": "Stan"
      },
      "tax": {
        "title": "Numer identyfikacji podatkowej"
      }
    }
  },
  "checkouts": {
    "header": "Kasa",
    "payment_method": "Wybierz metodę płatności",
    "stripe_card": "Karta kredytowa (Stripe)",
    "paypal": "PayPal",
    "address": {
      "new": "Wprowadź nowy adres rozliczeniowy",
      "existing": "Użyj istniejącego adresu"
    },
    "pay_stripe": "Potwierdź i zapłać",
    "terms": "Potwierdzając subskrypcję, zezwalasz Linguise na pobieranie od Ciebie kolejnych płatności zgodnie z naszymi warunkami. Zawsze możesz anulować subskrypcję.",
    "coupon": {
      "title": "Masz kupon?",
      "placeholder": "Wprowadź tutaj swój kod",
      "apply": "Zastosuj",
      "percent": "{{0}}% rabatu"
    },
    "add_new": "Dodaj nową",
    "use_existing": "Użyj istniejącej metody płatności",
    "recurring": {
      "month_single": "Rozliczane co miesiąc",
      "month_many": "Rozliczane co {{count}} miesiące",
      "year_single": "Rozliczane co rok",
      "year_many": "Rozliczane co {{count}} lata",
      "day_single": "Rozliczane codziennie",
      "day_many": "Rozliczane co {{count}} dni",
      "week_single": "Rozliczane co tydzień",
      "week_many": "Rozliczane co {{count}} tygodnie"
    },
    "add_new_no_stripe": "Dodaj nową kartę",
    "summary": {
      "title": "Podsumowanie",
      "subtotal": "Suma częściowa",
      "total": "Razem"
    }
  },
  "dashboard": {
    "main": {
      "title": "Panel"
    },
    "statistics": {
      "main_title": "Statystyki ostatnich 30 dni",
      "characters": "Znaki tłumaczone",
      "words": "Słowa tłumaczone",
      "bandwidth": "Przepustowość wejściowa",
      "request": "Żądania",
      "page_views": "Odsłony stron wg języków (ostatnie 30 dni)",
      "multilingual_views": "Odsłony stron wielojęzycznych (ostatnie 30 dni)",
      "most_page_viewed": "20 najczęściej oglądanych stron (ostatnie 30 dni)",
      "no_data_yet": "Brak danych",
      "th_language": "Język",
      "th_page_views": "Odsłony",
      "real_visitors": "Rzeczywiści odwiedzający",
      "crawler": "Robot indeksujący"
    },
    "planHints": {
      "subscribeButton": "Subskrybuj",
      "upgradeButton": "Ulepsz",
      "usedWords": "Aktualnie wykorzystujesz {words_used} słów",
      "noPlan": "Dla tej domeny nie aktywowano planu. Kup subskrypcję i zacznij tłumaczyć swoją stronę",
      "noPlanShopify": "Dla tej domeny nie aktywowano planu. Kup subskrypcję w panelu Shopify i zacznij tłumaczyć stronę",
      "trialUsage": "Korzystasz z {words_used} słów spośród {words_allowed} dozwolonych w planie próbnym.",
      "trialEnds": "Pierwszy miesiąc próbny aktywny do {trial_ends}.",
      "subscribeMessage": "Subskrybuj przed końcem, aby strona pozostała przetłumaczona",
      "subscribeMessageShopify": "Subskrybuj przez panel Shopify przed końcem, aby strona pozostała przetłumaczona",
      "trialReachedLimit": "Osiągnąłeś limit słów w okresie próbnym.\nWykup plan, aby kontynuować tłumaczenie strony.",
      "paidUsage": "Wykorzystałeś {words_used} / {words_allowed} słów w swoim planie.",
      "paidReachedLimit": "Osiągnąłeś limit słów w obecnym planie.\nUlepsz plan, aby kontynuować tłumaczenie treści.",
      "trialOfferedUsage": "Korzystasz z {words_used} słów spośród {words_allowed} dozwolonych w planie próbnym.(w tym {free_words} darmowych słów)",
      "paidOfferedUsage": "Wykorzystałeś {words_used} / {words_allowed} słów w swoim planie.(w tym {free_words} darmowych słów)",
      "noPlanExtra": "Uwaga: nieaktywne domeny i ich dane są regularnie automatycznie usuwane.",
      "planRecommended": "Na podstawie obecnego wolumenu tłumaczeń polecany plan to:",
      "planMaximumWords": "{{words}} słów",
      "notHaveTranslatedWords": "Nie wykonałeś jeszcze żadnych tłumaczeń"
    },
    "translationSetup": {
      "kicker": "KONFIGURACJA SUBDOMENY",
      "title": "Sprawdź konfigurację tłumaczenia",
      "description": "Sprawdź DNS, przetłumaczone hosty, dostęp do oryginalnej witryny i limity konta.",
      "starting": "Sprawdzanie...",
      "button": "Sprawdź konfigurację",
      "viewLatest": "Pokaż ostatni wynik",
      "viewCurrent": "Pokaż bieżące sprawdzenie",
      "runAgain": "Sprawdź ponownie",
      "viewDetails": "Pokaż szczegóły",
      "hideDetails": "Ukryj szczegóły",
      "error": "Nie można sprawdzić konfiguracji",
      "allPassed": "Wszystkie kontrole zakończone pomyślnie",
      "setupNeedsAttention": "Konfiguracja wymaga uwagi",
      "setupNeedsAttentionDescription": "Jedno lub więcej sprawdzeń nie powiodło się. Przejrzyj poniższe pozycje lub skontaktuj się z pomocą Linguise.",
      "lastChecked": "Ostatnie sprawdzenie: {{time}}",
      "domainOwnership": "Własność domeny",
      "domainOwnershipDescription": "Znaleziono rekord weryfikacyjny",
      "domainOwnershipFailure": "Nie udało się zweryfikować rekordu DNS własności.",
      "translatedHosts": "Przetłumaczone hosty",
      "translatedHostsDescription": "Sprawdzono hosty językowe: {{count}}",
      "translatedHostsFailure": "Co najmniej jeden językowy rekord CNAME jest nieprawidłowy.",
      "subdomainPage": "Strona subdomeny",
      "subdomainPageDescription": "{{count}} przetłumaczonych stron obsługuje HTTPS",
      "subdomainPageFailure": "Połączenie TLS nie powiodło się podczas otwierania co najmniej jednej przetłumaczonej strony.",
      "originalSite": "Oryginalna witryna",
      "originalSiteDescription": "Sprawdzenie DNS, TLS i odpowiedzi oryginalnej witryny",
      "originalSiteFailure": "Sprawdzenie DNS, TLS lub odpowiedzi oryginalnej witryny nie powiodło się.",
      "documentationAdvice": {
        "dns": "Sprawdź konfigurację DNS",
        "tls": "Sprawdź konfigurację HTTPS",
        "origin": "Sprawdź konfigurację oryginalnej witryny",
        "diagnostic": "Zapoznaj się z instrukcjami rozwiązywania problemów"
      },
      "evidence": {
        "originDns": "Oryginalny DNS",
        "originTls": "Oryginalny TLS",
        "originHttp": "Oryginalna odpowiedź",
        "observedTargets": "Wykryte cele",
        "recordCount": "Znalezione rekordy",
        "addressCount": "Znalezione adresy",
        "statusCode": "Status HTTP",
        "redirect": "Przekierowanie",
        "expiresAt": "Ważność certyfikatu wygasa",
        "raw": "{{key}}",
        "noValue": "Brak wartości"
      },
      "checkerError": "Nie udało się ukończyć niektórych sprawdzeń.",
      "coreLocation": "Sprawdzono z lokalizacji {{location}}",
      "status": {
        "queued": "W kolejce",
        "running": "W toku",
        "completed": "Ukończono",
        "failed": "Niepowodzenie",
        "passed": "Zaliczono",
        "warning": "Ostrzeżenie",
        "unknown": "Nieznany",
        "skipped": "Pominięto",
        "not_applicable": "Nie dotyczy"
      }
    },
    "throttling": {
      "title": "Limit tłumaczeń",
      "description": "Tymczasowe limity użycia",
      "unavailable": "Tymczasowe limity tłumaczeń są niedostępne",
      "window": "{{used}} / {{max}} słów",
      "resetsIn": "Reset za {{time}}",
      "throttled": "Tłumaczenie tymczasowo wstrzymane",
      "throttledDescription": "Osiągnięto tymczasowy limit użycia. Tłumaczenie zostanie wznowione po zresetowaniu tego okresu."
    }
  },
  "domain": {
    "wizard": {
      "stepLabel": "KROK {{step}} Z {{total}}",
      "doneLabel": "GOTOWE, MOŻESZ ZACZĄĆ TŁUMACZYĆ!",
      "finish": {
        "title": "",
        "description": "To klucz API do wykorzystania na swojej stronie"
      },
      "instructions": "Instrukcja instalacji",
      "domainSetting": "Ustawienia domeny",
      "step": {
        "titleWordpress": "WordPress",
        "titleJoomla": "Joomla",
        "titlePHP": "Skrypt PHP",
        "wizardWordpressStep1": "1. Zainstaluj ",
        "wizardWordpressStep2": "\n 2. W ustawieniach wtyczki skopiuj i wprowadź swój klucz API\n",
        "wizardWordpressStep3": "3. Jesteś gotowy do tłumaczenia\n\n",
        "wizardWordpressStep4": "Aby uzyskać bardziej szczegółowe instrukcje, zajrzyj do naszej dokumentacji: ",
        "wizardJoomlaStep1": "1. Link do pakietu Joomla: ",
        "wizardJoomlaStep2": "\n2. W ustawieniach konfiguracji rozszerzenia skopiuj i wprowadź swój klucz API",
        "wizardJoomlaStep3": "3. W konfiguracji modułu ustaw języki, które chcesz wyświetlać, i umieść moduł tam, gdzie potrzebujesz.",
        "wizardJoomlaStep4": "\n 4. Gotowe do tłumaczenia\n\n",
        "wizardPhpStep1": "1. Pobierz nasz skrypt php tutaj ",
        "wizardPhpStep2": "\n2. Postępuj zgodnie z instrukcją instalacji na stronie naszej dokumentacji tutaj ",
        "wizardPhpStep3": "\n3. Dodaj moduł do swoich stron.",
        "wizardPhpStep4": "\n Skopiuj poniższy kod i dodaj go do sekcji head swojej strony html — automatycznie wyświetli moduł przełącznika\n",
        "dispatchStep1": "Wysłaliśmy wymagane dane do wtyczki Linguise, możesz już zamknąć to okno.",
        "dispatchStep2": "W przypadku braku tokenu po zamknięciu tego okna skopiuj poniższy token:",
        "dispatchStep3": "Możesz też skopiować ten fragment, aby automatycznie włączyć nasz przełącznik flag",
        "wizardOtherStep1": "Postępuj zgodnie z poniższymi instrukcjami, aby zainstalować Linguise w swojej domenie.\n",
        "wizardOtherStep2": "Skopiuj poniższy kod i dodaj go do sekcji head swojej strony html — automatycznie wyświetli moduł przełącznika.\n"
      },
      "trialAlreadyUsed": "Wygląda na to, że Twój darmowy okres próbny został już wykorzystany, więc potrzebujesz wykupić limit tłumaczeń\nSubskrybuj plan lub skontaktuj się z nami, jeśli chcesz przedłużyć okres próbny.",
      "usefulLinks": "Przydatne linki na start",
      "linkDocumentation": "Dokumentacja",
      "linkExtensionDl": "Pobieranie rozszerzenia",
      "linkSubscribe": "Subskrybuj plan teraz",
      "linkDashboard": "Przejdź do panelu",
      "exclusion": {
        "title": "Nazwy firm i produktów",
        "description": ""
      },
      "finishButton": "Zakończ konfigurację",
      "subdomains": "Subdomeny",
      "subdomain_setup": "Skonfiguruj domenę",
      "subdomain_auto_setup": "Połącz DNS automatycznie",
      "subdomain_manual_setup": "Dodaj wpisy DNS samodzielnie",
      "subdomain_skip": "Zrób to później",
      "auto_subdomains_info": "Twój kreator stron wymaga konfiguracji DNS, aby ustawić języki na subdomenach (np. es.domena.com).",
      "auto_subdomains_info_2": "Możesz to zrobić automatycznie za pomocą Entri. Po prostu kliknij przycisk „Połącz DNS automatycznie”, aby połączyć się ze swoim menadżerem DNS i dodać je za pomocą Entri.",
      "auto_subdomains_info_manual": "Lub możesz ręcznie skonfigurować domenę, klikając przycisk „Dodaj wpisy DNS samodzielnie”.",
      "breadcrumbs": {
        "step1": "Krok 1: Domena, CMS i języki",
        "step2": "Krok 2: DNS języka",
        "step3": "Krok {{step}}: Instrukcje instalacji"
      }
    },
    "form": {
      "urls": {
        "dash": "Pauza -",
        "underscore": "Podkreślnik _",
        "title": "Tłumacz URL-e",
        "description": "Czy chcesz tłumaczyć na wszystkich stronach",
        "char_description": "Znak używany do zastępowania niedozwolonych znaków w URL-ach",
        "advertisement_title": "⚠ Ustawiłeś dużo języków.\n",
        "advertisement": "Zwykle zalecamy zacząć tłumaczenie strony od kilku języków. Dowiesz się wtedy, ile słów ma Twoja strona. Jest to też lepsze dla SEO, ponieważ roboty Google szybciej zaindeksują wszystkie strony, jeśli na początku jest ich mniej. Po tygodniu możesz dodać kolejne języki i tak dalej."
      },
      "url": {
        "title": "Adres URL",
        "description": "Wprowadź główny adres URL swojej domeny zaczynający się od http:// lub https://",
        "placeholder": "Adres URL domeny",
        "advertisement_http": {
          "title": "Nie używasz protokołu https",
          "description": "Sprawdź, czy Twoja domena faktycznie nie używa protokołu https, który jest dziś zalecany."
        },
        "advertisement_www": {
          "title": "Twoja subdomena to nie www",
          "description": "Najczęściej domyślną subdomeną jest www (np. https://www.mojadomena.com). Może to nie być Twój przypadek, ale upewnij się, czy dodawana domena jest właściwa."
        },
        "invalid_url": {
          "line1": "Nie udało nam się znaleźć Twojej domeny. Sprawdź, czy jest ona publicznie dostępna w Internecie i czy nie przekierowuje gdzieś indziej.",
          "line2": "Jeśli jesteś pewien, że domena jest dostępna, możesz pominąć weryfikację i ponownie kliknąć przycisk „Następny krok”",
          "contact": "W każdym razie możesz się z nami skontaktować pod adresem",
          "force": "Pomiń weryfikację domeny"
        },
        "invalid_subdomain_url": "Ten adres URL jest niedozwolony. Subdomeny muszą mieć format: https://www.domena.tld lub https://domena.tld bez podkatalogu."
      },
      "account": {
        "title": "Konto",
        "description": "Wybierz konto, któremu przypisać tę domenę",
        "placeholder": "Wybierz konto...",
        "feedback": "Musisz wybrać konto"
      },
      "platform": {
        "title": "Platforma",
        "description": "Wybierz platformę swojej strony po nazwie CMS.",
        "learn": "Dowiedz się, jak to wybrać",
        "placeholder": "Wyszukaj platformę po nazwie CMS...",
        "info": {
          "title": "⚠ Ta platforma została niedawno dodana.\n",
          "desc": "Ta platforma do budowy stron jest obsługiwana przez Linguise, choć została niedawno dodana. Jeśli napotkasz problem, skontaktuj się z nami bezpośrednio pod adresem:"
        },
        "description_read_only": "Platforma, na której działa Twoja strona",
        "feedback": "Musisz wybrać platformę"
      },
      "language": {
        "title": "Język",
        "description": "Wybierz język bazowy swojej strony",
        "placeholder": "Wybierz język...",
        "feedback": "Musisz wybrać język",
        "description_read_only": "Język bazowy Twojej strony"
      },
      "token": {
        "title": "Klucz API",
        "description": "To jest klucz API do skopiowania na swoją stronę",
        "copy": "Kopiuj do schowka",
        "reset": "Resetuj klucz API",
        "reset_confirm": "Potwierdź reset klucza API"
      },
      "languages": {
        "title": "Języki tłumaczeń",
        "description": "Wybierz języki, na które chcesz tłumaczyć swoją stronę",
        "placeholder": "Wybierz języki...",
        "feedback": "Musisz wybrać język"
      },
      "defaultRules": {
        "title": "Domyślne reguły",
        "description": "Zdefiniowaliśmy zestaw niezbędnych reguł, aby poprawić tłumaczenie i uniknąć przekładu niepożądanych treści, np. panelu WordPressa.\nPóźniej możesz je usunąć lub edytować, jeśli zechcesz."
      },
      "disallow_deletion": "Nie możesz usunąć domeny z aktywną subskrypcją",
      "delete_confirm": "Potwierdź usunięcie domeny",
      "delete": "Usuń domenę",
      "dynamic": {
        "title": "Tłumacz dynamiczne treści",
        "description": "Dynamiczne treści generowane przez JavaScript i żądania AJAX będą tłumaczone (ta opcja zwiększy Twoje zużycie tłumaczeń)"
      },
      "partial_translations": {
        "title": "Zezwól na częściowe tłumaczenia",
        "description": "Jeśli Twoje konto osiągnęło limit tłumaczeń, a strona nadal wymaga tłumaczenia, Linguise może kontynuować wyświetlanie strony z już przetłumaczoną treścią.\nCzęść strony pozostanie nietłumaczona, dopóki nie podwyższysz limitu.\n\nNiewielka ilość nietłumaczonej treści zwykle nie szkodzi SEO, lecz zbyt dużo może negatywnie wpłynąć na doświadczenie użytkownika.\nAby temu zaradzić, możesz ustawić próg procentu nietłumaczonych treści. Gdy ten próg zostanie przekroczony, użytkownicy będą automatycznie przekierowani do wersji oryginalnej strony.",
        "never": "Nigdy"
      },
      "translate_error_pages": {
        "title": "Tłumacz strony błędów",
        "description": "Linguise może tłumaczyć wszystkie strony błędów, lecz jeśli zawierają one dynamiczne treści, np. adres IP czy ID żądania, lepiej ich nie tłumaczyć.",
        "not_found_page": {
          "title": "Tłumacz stronę 404"
        },
        "error_page": {
          "title": "Tłumacz pozostałe strony błędów"
        }
      },
      "plugin_mode": {
        "modal": {
          "title": "Znaleziono istniejącą domenę",
          "description": "Znaleziono istniejącą domenę dla tego użytkownika, czy chcesz jej użyć?"
        }
      },
      "search_tl": {
        "title": "Szukaj tłumaczeń",
        "description": "Włącz wyszukiwanie tłumaczeń dla Twojej platformy (funkcja eksperymentalna, zwiększy zużycie tłumaczeń)"
      },
      "shopify_promo": {
        "info": "Dobra wiadomość! Mamy już natywną aplikację Shopify, którą możesz zainstalować ze sklepu Shopify App Store.",
        "hyperlink": "Kliknij tutaj i zainstaluj Linguise z aplikacji.",
        "next_btn": "Przejdź do sklepu Shopify, aby zainstalować aplikację",
        "info_legacy": "Dobra wiadomość! Mamy już natywną aplikację Shopify, którą możesz zainstalować ze sklepu Shopify App Store.",
        "description_legacy": "Wybierz platformę „Shopify” zamiast „Shopify Legacy”"
      },
      "wix_promo": {
        "info": "Dobra wiadomość! Mamy już natywną aplikację Wix, którą możesz zainstalować ze sklepu Wix App Market.",
        "hyperlink": "Kliknij tutaj i zainstaluj Linguise z aplikacji.",
        "next_btn": "Przejdź do Wix App Market, aby zainstalować aplikację",
        "info_legacy": "Dobra wiadomość! Mamy już natywną aplikację Wix, którą możesz zainstalować ze sklepu Wix App Market.",
        "description_legacy": "Wybierz platformę „Wix” zamiast „Wix Legacy”"
      },
      "ai_disallow_deletion": "Nie możesz usunąć tej domeny, dopóki limit AI jest nadal dostępny.\n\nJeśli chcesz usunąć tę domenę, skontaktuj się z naszym zespołem pomocy technicznej",
      "language_removal": {
        "card": {
          "title": "Usuń tłumaczenia usuniętych języków",
          "description": "Te języki zostały usunięte z Twojej witryny, ale zapisane tłumaczenia nadal wliczają się do limitu. Usuń je, aby odzyskać słowa.",
          "button": "Usuń tłumaczenia"
        },
        "hint": "Wykorzystane słowa wrócą do Twojego limitu. Możesz to zrobić raz na {{days}} dni dla każdej witryny.",
        "modal": {
          "title": "Usunąć tłumaczenia?",
          "intro": "Te tłumaczenia zostaną trwale usunięte:",
          "warning": "Tej operacji nie można cofnąć. Wykorzystane słowa wrócą do Twojego limitu, co może potrwać kilka minut.",
          "limit": "Możesz to zrobić raz na {{days}} dni dla każdej witryny.",
          "confirm": "Usuń tłumaczenia"
        },
        "scheduled": "Tłumaczenia są usuwane, a limit wkrótce zostanie zaktualizowany.",
        "cooldown": "Tłumaczenia tej witryny zostały niedawno usunięte. Ponownie możesz je usunąć {{date}}.",
        "latest_completed": {
          "title": "Ostatnie ukończone usuwanie",
          "description": "Sprawdź usunięte języki i słowa zwrócone do Twojego limitu.",
          "languages": "Usunięte języki",
          "words_returned": "Słowa zwrócone do limitu: {{words}}",
          "completed_at": "Ukończono {{date}}"
        },
        "status": {
          "recent_title": "Ostatnie usuwanie tłumaczeń",
          "recent_description": "Śledź ostatnie usuwanie i sprawdź, kiedy będzie można rozpocząć kolejne.",
          "progress_title": "Postęp usuwania",
          "loading": "Sprawdzanie postępu usuwania...",
          "unavailable": "Nie udało się wczytać postępu usuwania. Odśwież stronę i spróbuj ponownie.",
          "label": "Status",
          "pending": "W kolejce",
          "processing": "W toku",
          "completed": "Ukończono",
          "failed": "Niepowodzenie",
          "unknown": "Status niedostępny",
          "percent": "Ukończono w {{percent}}%",
          "current_stage": "Bieżący etap: {{stage}}",
          "processed": "Przetworzono rekordów: {{processed}}",
          "processed_total": "Przetworzono {{processed}} z {{total}} rekordów",
          "requested_at": "Zażądano {{date}}",
          "started_at": "Rozpoczęto {{date}}",
          "completed_at": "Ukończono {{date}}",
          "cooldown_period": "Możesz to zrobić raz na {{days}} dni dla każdej witryny.",
          "cooldown_blocked": "Nie można jeszcze rozpocząć kolejnego usuwania.",
          "stage": {
            "queued": "Oczekiwanie na rozpoczęcie",
            "processing": "W toku",
            "refund_summary": "Obliczanie zwróconych słów",
            "search_translations": "Usuwanie tłumaczeń wyszukiwania",
            "url_translations": "Usuwanie tłumaczeń adresów URL",
            "translations": "Usuwanie tłumaczeń",
            "completed": "Ukończono",
            "failed": "Niepowodzenie",
            "unknown": "W toku"
          }
        },
        "forbidden": "Nie masz uprawnień do usuwania tłumaczeń."
      }
    },
    "main": {
      "edit": "Edytuj domenę",
      "add": "Dodaj domenę",
      "wizard": "Witamy! Kreator tworzenia nowej domeny",
      "common": "Domena"
    },
    "notice": {
      "broken_card": "Nie mogliśmy odnowić planu dla {{url}} przy użyciu obecnej metody płatności, zaktualizuj swoją kartę płatniczą",
      "quota_reached": "Osiągnięto limit tłumaczeń dla {{url}}, podnieś plan, aby wznowić tłumaczenie strony",
      "ai_no_subscription": "Tłumaczenie AI dla {{url}} wymaga aktywnej subskrypcji lub aktywnego okresu próbnego. Bez niego zostanie zatrzymane, rozwiń plan, aby kontynuować",
      "important": "Ważne",
      "quota_reached_button": "Zaktualizuj swój plan teraz",
      "broken_card_button": "Zaktualizuj swoją kartę płatniczą",
      "ai_no_subscription_button": "Zaktualizuj swój plan teraz",
      "quota_warning": "Twój limit tłumaczeń dla {{url}} osiągnął {{throttling_used_percent}}%, zostanie on zresetowany za {{ttl}}",
      "locked": "Domena {{url}} jest obecnie zablokowana do migracji. Nadal możesz uzyskać dostęp do swojej witryny, ale nie możesz edytować ani dodawać nowych tłumaczeń!"
    },
    "subdomains": {
      "config_ok": "Konfiguracja DNS subdomen została wykonana prawidłowo.",
      "config_invalid": "Konfiguracja DNS subdomen wymaga dodatkowej konfiguracji, aby działać.",
      "config_check": "Sprawdzana jest konfiguracja DNS subdomen, proszę czekać...",
      "entri_timeout": "Entri zgłosiło, że proces propagacji DNS Twoich subdomen przekroczył czas; musisz spróbować ponownie lub wykonać to ręcznie.",
      "entri_process": "Twoje rekordy DNS zostały dodane przez Entri i zwykle zajmuje to 10–30 minut na propagację (zastosowanie wszystkich subdomen językowych, np. es.domain.com). Jeśli walidacja DNS nie zostanie zakończona po 24 godzinach, możesz skontaktować się z naszym zespołem wsparcia: support@linguise.com",
      "entri_ok": "Propagacja DNS trwa! Oczekiwanie na propagację...",
      "infos": "Aby aktywować tłumaczenie, musisz dodać te wpisy DNS do rekordów domeny DNS. Kliknij przycisk „Sprawdź”, gdy tłumaczenie zostanie wykonane. Propagacja rekordów DNS może zająć trochę czasu, więc może być konieczne ponowne uruchomienie po kilku minutach lub godzinach.",
      "check": "Sprawdź konfigurację DNS"
    },
    "subscription": {
      "next_payment_amount": "Nadchodzące opłaty",
      "next_payment_date": "Data następnej płatności",
      "invoice": {
        "header": "Historia faktur",
        "date": "Data",
        "amount_due": "Kwota",
        "status": "Status",
        "actions": "Akcje",
        "description": "Gdy transakcje będą dostępne, zobaczysz je tutaj.",
        "status_text": {
          "draft": "Szkic",
          "failed": "Nieudana",
          "open": "Oczekująca",
          "paid": "Opłacona",
          "retrying": "Ponawianie",
          "uncollectible": "Nieściągalna",
          "void": "Nieważna"
        },
        "view": "Zobacz",
        "empty": "Nie znaleziono ostatnich faktur dla tej subskrypcji",
        "retry_payment": "Spróbuj ponownie"
      },
      "next_cancellation": "Data anulowania",
      "cancel": "Anuluj subskrypcję",
      "change_plan": "Zmień plan",
      "change": "Zmień",
      "suspend": "Wstrzymaj płatność",
      "resume": "Wznów subskrypcję",
      "back": "Powrót",
      "save": "Zapisz",
      "confirm_resume": "Czy na pewno chcesz wznowić tę subskrypcję?",
      "confirm_cancel": "Czy na pewno chcesz anulować tę subskrypcję?",
      "confirm_header": "Czy jesteś pewien?",
      "missing_status": "Brakuje tej subskrypcji",
      "not_found": "Nie znaleziono subskrypcji dla tej domeny",
      "confirm_manual_retry": "Czy na pewno chcesz ponowić tę płatność?",
      "no_payment_method": "Nieznany",
      "remove_billing": "Usuń",
      "shopify_maneged": "Ta subskrypcja jest zarządzana przez Shopify. Zarządzaj nią z poziomu panelu administracyjnego Shopify.",
      "unknown_plan": "Nieznany plan"
    }
  },
  "domain_listing": {
    "add": "Dodaj stronę",
    "select": "Wybierz domenę"
  },
  "editable": {
    "number": "numer {{id}}"
  },
  "footer": {
    "about": "O nas",
    "support": "Wsparcie"
  },
  "frontendEditor": {
    "main": "Edytor na żywo",
    "description": "Edytor na żywo pozwala bezpośrednio edytować tłumaczenia na Twojej stronie.",
    "button": "Otwórz Edytor na żywo",
    "language_selection": "Wybór języka tłumaczenia",
    "video_label": "Naucz się korzystać z edytora na żywo"
  },
  "general": {
    "403": {
      "tab_title": "Ups – Błąd 403",
      "title": "Dostęp zabroniony",
      "message": "Wygląda na to, że nie masz dostępu do żądanej strony.",
      "home": "Wróć do strony głównej"
    },
    "404": {
      "tab_title": "Ups – Błąd 404",
      "title": "Nie znaleziono strony",
      "message": "Wygląda na to, że zabłądziłeś. Nie martw się... zdarza się nawet najlepszym. Oto mała wskazówka, która pomoże Ci wrócić na właściwą ścieżkę.",
      "home": "Wróć do strony głównej"
    },
    "500": {
      "tab_title": "Błąd 500",
      "title": "Błąd wewnętrzny serwera",
      "message": "Może odświeżysz stronę? Lub możesz się z nami skontaktować",
      "home": "Wróć do strony głównej"
    },
    "fields": {
      "alert": "Niektóre pola są nieprawidłowe, popraw błędne pola.",
      "invalid": "To pole jest nieprawidłowe",
      "phone_re": "Numer telefonu jest nieprawidłowy",
      "phone_invalid": "Numer telefonu jest nieprawidłowy",
      "email": "Pole e-mail jest nieprawidłowe"
    },
    "table": {
      "no_data": "Nie ma jeszcze danych..."
    },
    "saving": "Zapisywanie...",
    "save": "Zapisz",
    "save_and_quit": "Zapisz i wyjdź",
    "invite": "Zaproś",
    "cancel": "Anuluj",
    "yes": "Tak",
    "no": "Nie",
    "nextStep": "Następny krok",
    "loading": "Proszę czekać, aplikacja się ładuje",
    "goback": "Wróć",
    "manage": "Zarządzaj",
    "delete": "Usuń",
    "deleting": "Usuwanie...",
    "confirm": "Potwierdź",
    "unknown": "Nieznany",
    "hide": "Ukrywać",
    "show": "Pokazywać",
    "on": "NA",
    "off": "Wyłączony",
    "default": "Domyślny"
  },
  "home": {
    "header": "Strona główna",
    "manage": "Zarządzaj subskrypcją",
    "canceled": "Zaplanowano anulowanie",
    "activate_now": "Aktywuj teraz",
    "activate_plan_now": "Zasubskrybuj teraz",
    "upgrade_plan_now": "Ulepsz plan teraz",
    "trial_message_part_1": "Aktualnie korzystasz z planu próbnego, ",
    "trial_message_part_2": "możesz aktywować członkostwo w dowolnym momencie.",
    "add": "Dodaj domenę",
    "table": {
      "title": "Domeny",
      "description": "Lista Twoich domen, kliknij domenę, aby zarządzać tłumaczeniami"
    },
    "domains": {
      "empty": "Nie masz jeszcze żadnych domen na tym koncie"
    },
    "accountsList": {
      "title": "Konta",
      "add": "Dodaj nowe konto",
      "name": "Nazwa konta"
    },
    "update_credit_card": "Zaktualizuj dane karty kredytowej",
    "cancelling_subs": "Anulowanie o {{0}}",
    "resume_subscription": "Wznów subskrypcję",
    "shopify_managed": "Zarządzane przez Shopify",
    "trial_ends_at": "Kończy się o {{0}}",
    "free_trial": "Bezpłatny okres próbny",
    "no_subs": "Brak aktywnej subskrypcji"
  },
  "invoices": {
    "title": "Faktury",
    "list": {
      "title": "Lista faktur"
    },
    "table": {
      "customer": "Klient",
      "domain": "Domena",
      "amountPaid": "Zapłacona kwota",
      "status": "Status",
      "date": "Data",
      "invoice": "Faktura",
      "pay": "Zapłać fakturę",
      "actions": "Akcje",
      "deleted_domain": "Domena usunięta",
      "plan_name": "Plan",
      "action": "Akcja"
    },
    "listPending": {
      "title": "Lista oczekujących faktur"
    }
  },
  "language_settings": {
    "display": "Wyświetlanie listy języków",
    "position": "Pozycja",
    "display_help_text": "Wyświetlaj flagę i/lub nazwy języków. Domyślna pozycja przełącznika języków może być gdziekolwiek w treści lub w pozycji stałej, która pozostaje nieruchoma lub przesuwa się podczas przewijania",
    "side_by_side": "Obok siebie",
    "dropdown": "Lista rozwijana",
    "popup": "Wyskakujące okno",
    "flag": "Flaga",
    "lang_name": "Nazwa języka",
    "lang_short_name": "Krótkie nazwy",
    "positions": {
      "in_place": "Na miejscu",
      "top_left": "Lewy górny",
      "top_left_no_scroll": "Lewy górny (bez przewijania)",
      "top_right": "Prawy górny",
      "top_right_no_scroll": "Prawy górny (bez przewijania)",
      "bottom_left": "Lewy dolny",
      "bottom_left_no_scroll": "Lewy dolny (bez przewijania)",
      "bottom_right": "Prawy dolny",
      "bottom_right_no_scroll": "Prawy dolny (bez przewijania)"
    },
    "lang_names_display": {
      "title": "Wyświetlanie nazw języków",
      "help_text": "W przełączniku języków wyświetlaj nazwy języków po angielsku lub w oryginalnym języku, np. French lub Français",
      "english": "Angielski",
      "native_languages": "Języki ojczyste"
    },
    "flag_shape": {
      "title": "Styl flagi",
      "help_text": "Użyj okrągłych lub prostokątnych ikon flag w formacie svg",
      "round": "Okrągła",
      "rectangular": "Prostokątna"
    },
    "english_flag_type": {
      "title": "Typ flagi angielskiej",
      "help_text": "Użyj flagi Wielkiej Brytanii lub USA dla języka angielskiego",
      "usa": "Flaga USA",
      "great_britain": "Flaga Wielkiej Brytanii"
    },
    "german_flag_type": {
      "title": "Typ flagi niemieckiej",
      "help_text": "Użyj flagi Austrii lub Niemiec dla języka niemieckiego",
      "german": "Flaga niemiecka",
      "austria": "Flaga austriacka"
    },
    "spain_flag_type": {
      "title": "Typ flagi hiszpańskiej",
      "help_text": "Użyj flagi Meksyku lub Hiszpanii dla języka hiszpańskiego",
      "spanish": "Flaga hiszpańska",
      "mexico": "Flaga meksykańska",
      "peruvian": "Flaga peruwiańska"
    },
    "portugal_flag_type": {
      "title": "Typ flagi portugalskiej",
      "help_text": "Użyj flagi Portugalii lub Brazylii dla języka portugalskiego",
      "portugal": "Flaga portugalska",
      "brazil": "Flaga brazylijska"
    },
    "taiwanese_flag_type": {
      "title": "Typ flagi tajwańskiej",
      "help_text": "Użyj flagi Tajwanu lub Chin dla języka tajwańskiego",
      "taiwanese": "Flaga tajwańska",
      "chinese": "Flaga chińska"
    },
    "flag_border_radius": {
      "title": "Promień zaokrąglenia flagi (px)",
      "help_text": "Jeśli używasz prostokątnego kształtu flagi, możesz zastosować niestandardowy promień zaokrąglenia w pikselach"
    },
    "flag_width": {
      "title": "Rozmiar flagi (px)",
      "help_text": "Wybierz rozmiar flag w pikselach. To nie zmienia wagi obrazka, ponieważ jest to format .svg"
    },
    "lang_color": {
      "color_title": "Kolor nazwy języka",
      "color_help_text": "Wybierz domyślny kolor tekstu dla nazw języków",
      "hover_color_title": "Kolor nazwy języka po najechaniu",
      "hover_color_help_text": "Wybierz kolor tekstu nazwy języka po najechaniu myszką",
      "color_popup_title": "Kolor języka w wyskakującym oknie",
      "color_popup_help_text": "Kolor tytułu języka w obszarach wyskakujących okien lub list rozwijanych",
      "hover_color_popup_title": "Kolor języka w wyskakującym oknie po najechaniu",
      "hover_color_popup_help_text": "Wybierz kolor tekstu tytułu języka w wyskakujących oknach lub listach rozwijanych po najechaniu myszką"
    },
    "flag_box_shadow": {
      "shadow_title": "Cień flagi",
      "shadow_help_text": "Kolor i rozmiar cienia dla flag językowych",
      "hover_shadow_title": "Cień flagi po najechaniu",
      "hover_shadow_help_text": "Kolor i rozmiar cienia dla flag językowych po najechaniu myszką",
      "shadow_h_offset": "Przesunięcie poziome cienia (px)",
      "shadow_v_offset": "Przesunięcie pionowe cienia (px)",
      "shadow_blur": "Rozmycie cienia (px)",
      "shadow_spread": "Rozciągnięcie cienia (px)",
      "shadow_color": "Kolor cienia"
    },
    "order": "Kolejność języków",
    "language_order_help": "Kolejność języków, która będzie pokazywana w przełączniku języków. Możesz przeciągać i upuszczać języki, aby zmienić ich kolejność.",
    "order_reset": "Resetuj kolejność",
    "language_order_dragdrop": "Możesz przeciągać i upuszczać języki, aby zmienić ich kolejność.",
    "popup_lang_name": "Nazwa języka w wyskakującym oknie",
    "preview": "Podgląd języka"
  },
  "link": {
    "form": {
      "original": {
        "title": "Oryginalne źródło",
        "description": "Dodaj swój oryginalny adres URL linku i zastąp go poniżej według języka, aby go przetłumaczyć",
        "srcset_description": "Edytujesz adres URL obrazu. Upewnij się, że przeczytałeś dokumentację, zwłaszcza jeśli używasz srcset lub nie wiesz, co to jest",
        "link": "Łącze",
        "match_link": "Tryb dopasowania",
        "match_exact": "Dokładny",
        "match_wildcard": "Wieloznacznik",
        "match_regex": "Wyrażenie regularne"
      },
      "alternative_languages": {
        "title": "Linki do zamiany",
        "description": "Zamień linki do mediów i linki zewnętrzne na wszystkich stronach według języka…",
        "link": "Link do zamiany"
      },
      "error": {
        "atLeastOne": "Dodaj co najmniej jedno tłumaczenie.",
        "url": "Adres URL jest nieprawidłowy",
        "extension": "Link musi mieć rozszerzenie, ale nie może to być .html ani .php. Link nie może też zawierać ścieżki językowej, np. \"/fr\"",
        "regex": "Wyrażenie regularne jest nieprawidłowe",
        "wildcard": "Link z wieloznacznikiem ma nieprawidłowy protokół"
      }
    },
    "main": {
      "parent": "Linki",
      "edit": "Edytuj link"
    }
  },
  "links": {
    "title": "Zarządzanie linkami do mediów i zewnętrznymi",
    "description": "Przeglądaj i edytuj linki do mediów lub zewnętrzne na swojej stronie.",
    "add": "Dodaj link",
    "delete": "Usuń link",
    "table": {
      "original": "Oryginał",
      "language": "Język",
      "translation": "Tłumaczenie",
      "action": "Akcja",
      "delete_confirm": "Potwierdź usunięcie linku"
    }
  },
  "members": {
    "header": "Członkowie",
    "invite": "Zaproś nowego członka",
    "modal": {
      "inviteHeader": "Zaproś nowego członka",
      "editHeader": "Edytuj członka",
      "detachHeader": "Odłącz członka",
      "detachBody": "Czy na pewno chcesz odłączyć członka od tego konta?",
      "selfDetachBody": "Czy na pewno chcesz odłączyć się od zarządzania tym kontem? Po tej operacji nie będziesz mieć dostępu do żadnych danych związanych z tym kontem."
    },
    "table": {
      "title": "Lista członków",
      "description": "Role członków i dostęp do domen",
      "name": "Nazwa",
      "email": "E-mail",
      "websites": "Strony",
      "languages": "Języki",
      "role": "Rola",
      "status": "Status",
      "resendInvite": "wyślij ponownie",
      "inviteSent": "zaproszenie wysłane",
      "actions": "Akcje",
      "edit": "Edytuj",
      "detach": "Odłącz",
      "empty": "Nie masz jeszcze żadnych członków",
      "all_website": "Wszystkie strony i języki",
      "roles": {
        "admin": "Administrator",
        "manager": "Menadżer",
        "translator": "Tłumacz"
      },
      "statuses": {
        "pending": "Oczekujące",
        "accepted": "Zaakceptowane",
        "declined": "Odrzucone"
      }
    },
    "errors": {
      "role": "Musisz wybrać rolę",
      "domains": "Musisz wybrać co najmniej 1 stronę dla wybranej roli",
      "languages": "Musisz wybrać co najmniej 1 język dla wybranych stron"
    },
    "inviteSent": "Zaproszenie zostało pomyślnie wysłane"
  },
  "pagination": {
    "showing": "Pokazywanie {{limit}} z {{total}} wyników",
    "showing_only_count": "Pokazywanie {{limit}} wyników"
  },
  "payments_method": {
    "header": "Metody płatności",
    "table": {
      "title": "Lista metod płatności",
      "description": "Metody płatności przypisane do Twojego konta",
      "default": "Domyślna",
      "action_edit_remove": "Edytuj lub usuń",
      "action_remove": "Usuń",
      "action_default": "Ustaw jako domyślną",
      "action_fallback": "Ustaw jako zapasową",
      "expires": "Wygasa",
      "add_new_card": "Dodaj metodę płatności",
      "action_fallback_remove": "Usuń z zapasowych",
      "fallback": "Zapasowa",
      "action_edit": "Edytuj",
      "action_delete": "Usuń",
      "action_default_remove": "Usuń jako domyślną",
      "domain_count@@one": "Używana przez {{count}} domeny",
      "domain_count@@other": "Używane przez {{count}} domen"
    },
    "paypal_bind": {
      "button": "Połącz konto PayPal",
      "button_load": "Łączenie...",
      "disconnected": "Niepołączone",
      "success": "Twoje konto PayPal zostało połączone, 5 USD zostanie odjęte od Twojej następnej faktury!",
      "success_no_promo": "Twoje konto PayPal zostało połączone",
      "error": "Wystąpił błąd",
      "success_header": "Sukces"
    },
    "card_add": {
      "header": "Dodaj nową kartę",
      "success": "Nowa karta została podłączona do Linguise!",
      "terms": "Podając informacje o karcie, zezwalasz Linguise na obciążanie karty przyszłymi płatnościami zgodnie z naszymi warunkami świadczenia usług."
    },
    "card_detail": {
      "header": "Informacje o karcie",
      "delete": {
        "error": "Nie możesz usunąć tej metody płatności, ponieważ ma aktywne subskrypcje!"
      }
    },
    "subscriptions": {
      "table": {
        "description": "Subskrypcje przypisane do tej metody płatności",
        "header_domain": "Domena",
        "header_plan": "Plan",
        "header_status": "Status",
        "header_actions": "Akcje",
        "cancelling": "Anulowanie: {{0}}",
        "next_payment": "Następna płatność: {{0}}",
        "action_renew": "Odnów",
        "no_subs_header": "Brak subskrypcji do wyświetlenia",
        "no_subs_desc": "Gdy subskrypcja zostanie przypisana do tej karty, wszystkie informacje pojawią się tutaj",
        "action_manage": "Zarządzaj"
      },
      "status": {
        "active": "Aktywna",
        "canceled": "Anulowana",
        "incomplete": "Nieopłacona",
        "incomplete_expired": "Nieopłacona (wygasła)",
        "missing": "Błąd",
        "past_due": "Zaległa",
        "trialing": "Okres próbny",
        "unpaid": "Nieopłacona"
      }
    },
    "delete_confirm_body": "Czy na pewno chcesz usunąć tę metodę płatności? Tej operacji nie można cofnąć!",
    "delete_confirm_header": "Usunąć metodę płatności?",
    "card_edit": {
      "header": "Edytuj kartę",
      "billing_header": "Dane rozliczeniowe",
      "address_error": "Adres jest wymagany!",
      "card_number": "Numer karty",
      "card_expiry": "Data ważności",
      "expiry_error_month": "Podano nieprawidłowy miesiąc",
      "expiry_error_year": "Podano nieprawidłowy rok",
      "expiry_error_expired": "Rok ważności Twojej karty już minął.",
      "card_header": "Dane karty",
      "expiry_error_empty": "To pole jest wymagane!"
    }
  },
  "plans": {
    "per": "za",
    "wordsTranslated": "przetłumaczonych słów",
    "current": "Obecny",
    "archived": "Zarchiwizowany",
    "day": "dzień",
    "week": "tydzień",
    "month": "miesiąc",
    "year": "rok",
    "activate": "Aktywuj",
    "cancel": "Anuluj",
    "change": "Zmień",
    "upgrade": "Ulepsz",
    "downgrade": "Obniż",
    "resume": "Wznów",
    "notEnoughWords": "Za mało słów",
    "yearIntervalOnly": "Nie można migrować z planu rocznego",
    "subsCanceled": "Trwa anulowanie innej subskrypcji",
    "wordsUnlimited": "Nieograniczone słowa",
    "tabs": {
      "day": "Ceny dzienne",
      "week": "Ceny tygodniowe",
      "month": "Ceny miesięczne",
      "year": "Ceny roczne",
      "sub_texts": {
        "day": "Jedna stała cena, codziennie",
        "week": "Jedna stała cena, co tydzień",
        "month": "Jedna stała cena, co miesiąc",
        "year": "Jeden miesiąc za darmo, jedna płatność rocznie"
      }
    },
    "details": {
      "new_languages": "Dodawaj nowe języki w dowolnym momencie",
      "one_month_trial": "Bezpłatny miesiąc próbny dla każdej nowej strony",
      "multi_content_indexed": "100% wielojęzycznej zawartości zaindeksowane",
      "translate_new_content": "Tłumacz nową zawartość natychmiast",
      "free_installation": "Darmowa instalacja i konfiguracja",
      "compared_monthly_plan": "Jeden miesiąc za darmo w porównaniu do planów miesięcznych",
      "risk_free_recurring": "Bezpieczne płatności cykliczne",
      "unlimited_languages": "Nieograniczone języki i odsłony stron",
      "high_server_resources": "Wysokie zasoby serwera",
      "billed": {
        "day": "Rozliczane codziennie",
        "week": "Rozliczane co tydzień",
        "month": "Rozliczane co miesiąc",
        "year": "Rozliczane co rok"
      },
      "request_max_size": "Maks. rozmiar {{0}} zapytań"
    },
    "frequent_question": {
      "title": "Częste pytania",
      "questions": {
        "trial": {
          "question": "Czy mogę skorzystać z okresu próbnego na nowej domenie?",
          "answer": "Tak, oferujemy 30-dniowy bezpłatny okres próbny dla każdej nowej domeny dodanej do konta. W ten sposób możesz w pełni przetestować usługę tłumaczenia na nowej stronie."
        },
        "seo": {
          "question": "Ile czasu zajmuje poprawa SEO?",
          "answer": "Treść wielojęzyczna potrzebuje czasu, aby zostać w pełni zaindeksowana i dobrze oceniona. W zależności od ruchu i rozmiaru strony trwa to od 3 do 6 tygodni."
        },
        "quota": {
          "question": "Czy tłumaczenia ludzkie są wliczane do limitu?",
          "answer": "Nie, limit słów dotyczy tylko automatycznych tłumaczeń maszynowych. Tłumacz może ręcznie edytować automatyczne tłumaczenia bez ograniczeń."
        }
      }
    },
    "best_offer": "Najlepsza oferta",
    "period": {
      "days@@one": "dzień",
      "days@@other": "{{count}} dni",
      "hours@@one": "godzina",
      "hours@@other": "{{count}} godziny",
      "minutes@@one": "minuta",
      "minutes@@other": "{{count}} minut",
      "seconds@@one": "sekunda",
      "seconds@@other": "{{count}} sekund"
    },
    "words": {
      "billion": "{{value}} mld",
      "million": "{{value}} mln",
      "thousand": "{{value}} tys."
    },
    "throttling_info": "{{words}} słów na {{period}}"
  },
  "profile": {
    "welcome": "Witamy!",
    "account": "Moje konto",
    "subscriptions": "Subskrypcje",
    "logout": "Wyloguj"
  },
  "register": {
    "errors": {
      "password": "Minimum 8 znaków, dowolne znaki"
    }
  },
  "route": {
    "dashboard": "Panel",
    "rules": "Zasady",
    "translations": "Tłumaczenia",
    "search_translations": "Zapytania wyszukiwania",
    "urls_translations": "Tłumaczenia adresów URL",
    "links": "Media i linki zewnętrzne",
    "online_editor": "Edytor na żywo",
    "settings": "Ustawienia",
    "domain": {
      "finish": "Ustawienia",
      "preconfig": "Ustawienia"
    },
    "home": "Strona główna",
    "domain_list": "Lista domen",
    "members": "Członkowie",
    "invoices": "Faktury",
    "billing": "Dane rozliczeniowe",
    "language_display": "Wyświetlanie flag językowych",
    "payment_methods": "Metody płatności",
    "ai_translation": "Tłumaczenie AI",
    "ai_translation_settings": "Ustawienia",
    "ai_translation_pricing": "Cennik"
  },
  "rule": {
    "form": {
      "text_ignore": {
        "placeholder": "Tekst do ignorowania",
        "add": "Dodaj nowy",
        "title": "Tekst do ignorowania",
        "description": "Dodaj jeden lub kilka tekstów do ignorowania",
        "ignore_case": "Ignoruj wielkość liter"
      },
      "html_content": {
        "title": "Zastosuj do zawartości HTML",
        "description": "Zastosuj regułę na całej zawartości lub wybierz konkretny selektor CSS",
        "all_page": "Cała strona",
        "css_selector": "Selektor CSS",
        "label": "Selektor CSS",
        "placeholder": "Selektor do zastosowania",
        "add": "Dodaj nowy"
      },
      "apply_to_urls": {
        "title": "Zastosuj do adresów URL",
        "description": "Wybierz konkretne adresy URL, dla których ma obowiązywać reguła",
        "all_urls": "Wszystkie adresy URL",
        "selected_urls": "Wybrane adresy URL",
        "label": "Adres URL do zastosowania",
        "placeholder": "Adres URL do zastosowania",
        "original_url": "Oryginalne adresy URL",
        "translated_url": "Przetłumaczony adres URL",
        "wildcard": "Symbol wieloznaczny",
        "regex": "Wyrażenie regularne",
        "add": "Dodaj nowy",
        "expression": "Typ wyrażenia"
      },
      "apply_urls": {
        "title_exclude": "Wyklucz w adresach URL",
        "title_replace": "Zastąp w adresach URL",
        "title_description": "Stosuj tę regułę również do tłumaczenia adresów URL"
      },
      "apply_languages": {
        "title": "Zastosuj do języków",
        "description": "Wybierz konkretne języki, dla których ma obowiązywać reguła",
        "all_languages": "Wszystkie języki",
        "selected_languages": "Wybrane języki",
        "placeholder": "Wybierz języki...",
        "feedback": "Musisz wybrać język"
      },
      "name": {
        "title": "Tytuł",
        "description": "Nadaj regule tytuł dla wygody",
        "placeholder": "Nazwa reguły"
      },
      "type": {
        "title": "Typ",
        "description": "Wybierz typ reguły, którą chcesz dodać",
        "text_ignore": "Ignorowanie tekstu",
        "text_replace": "Zastępowanie tekstu",
        "content_exclusion": "Wykluczanie treści",
        "url_exclusion": "Wykluczenie po adresie URL",
        "ignore_inline": "Ignoruj w wierszu",
        "full_description": {
          "text_ignore": "Dodaj reguły, aby zapobiec tłumaczeniu niektórych tekstów. Może to być nazwa Twojego produktu, marki lub inne elementy techniczne, których nie chcesz tłumaczyć.",
          "text_replace": "Zastępowanie tekstu pozwala zastąpić pewne teksty własnym tłumaczeniem; może być konieczne, gdy tłumaczenie nie uwzględnia kontekstu.",
          "content_exclusion": "Wykluczanie treści pomoże uniknąć tłumaczenia niektórych fragmentów strony.\n Jeśli chcesz całkowicie wykluczyć stronę z tłumaczenia (brak wielojęzycznego adresu URL i przetłumaczonej treści), użyj typu „Wykluczenie po adresie URL”.",
          "url_exclusion": "Wykluczenie tłumaczenia strony pomoże ustalić strony, których nie chcesz tłumaczyć.",
          "ignore_inline": "Unikaj tłumaczenia niektórych treści jako zawartości w wierszu; tłumacz każdy znacznik osobno."
        }
      },
      "text_replace": {
        "title": "Tekst do zastąpienia",
        "description": "Zastąp dowolny tekst na całej stronie, według języka…",
        "text_to_replace": "Tekst do zastąpienia",
        "ignore_case": "Ignoruj wielkość liter",
        "text_type": "Zastępowanie w tłumaczeniu",
        "text_type_original": "Oryginał",
        "text_type_translation": "Tłumaczenie",
        "keep_case": "Staraj się zachować wielkość liter",
        "add": "Dodaj nowy"
      },
      "content_exclusion": {
        "title": "Wykluczanie treści",
        "description": "Wybierz jeden lub więcej selektorów CSS, które nie będą tłumaczone",
        "label": "Selektor CSS",
        "placeholder": "Selektor do zastosowania",
        "add": "Dodaj nowy"
      },
      "multilingual_url": {
        "title": "Użyj wielojęzycznego adresu URL",
        "description": "Jeśli ustawione na Tak, adres URL nie będzie tłumaczony, ale strona pozostanie wielojęzyczna z przetłumaczoną treścią",
        "live_example_title": "Przykład na żywo",
        "live_example_description": "Adres źródłowy: https://yourwebsite.com/page-not-translated",
        "live_example_multilingual": "Wygenerowany adres: https://yourwebsite.com/fr/page-not-translated",
        "live_example_no_multilingual": "Wygenerowany adres: https://yourwebsite.com/page-not-translated"
      },
      "rule_application": {
        "description": "Stosuj regułę do treści statycznych, dynamicznych albo obu",
        "title": "Zastosuj do treści",
        "all": "Wszystkie treści",
        "static": "Treści statyczne",
        "dynamic": "Treści dynamiczne"
      },
      "force_apply_urls": {
        "title_description": "Wymuś stosowanie tej reguły do wszystkich tłumaczeń adresów URL, w tym istniejących!",
        "title_replace": "Wymuś zastępowanie w adresach URL",
        "title_exclude": "Wymuś wykluczanie w adresach URL",
        "warning": "Ostrzeżenie",
        "warning_part1": "Ustawienie tego na „Tak” może zepsuć tłumaczenia adresów URL na Twojej stronie.",
        "warning_part2": "Może to tymczasowo lub na stałe generować błędy 404 – kontynuuj tylko, jeśli rozumiesz konsekwencje.",
        "warning_replacement_original": "Dodatkowe ostrzeżenie: Próbujesz zastąpić oryginalną treść, która może wpłynąć na adres URL; tłumaczenie może się nie powieść, ponieważ Linguise nie będzie w stanie prawidłowo znaleźć oryginalnych adresów URL."
      }
    },
    "main": {
      "parent": "Reguły",
      "edit": "Edytuj regułę",
      "add": "Nowa reguła"
    }
  },
  "rules": {
    "text_ignore": {
      "preview_single_with_url": "„{{text_ignore}}” będzie ignorowany w treści i w adresie URL",
      "preview_single": "„{{text_ignore}}” będzie ignorowany w treści",
      "preview_more_with_url": "„{{text_ignore}}” i jeszcze {{count}} będą ignorowane w treści",
      "preview_more": "„{{text_ignore}}” i jeszcze {{count}} będą ignorowane w treści",
      "other_parameters": "Dla tej reguły ustawiono inne parametry – kliknij przycisk edycji, aby uzyskać więcej informacji"
    },
    "text_replace": {
      "preview_single_with_url": "„{{original}}” jest zastępowany przez „{{replacement}}” w treści i w adresach URL",
      "preview_single": "„{{original}}” jest zastępowany przez „{{replacement}}” w treści",
      "preview_more_with_url": "„{{original}}” jest zastępowany przez „{{replacement}}” w treści i w adresach URL, oraz {{nb}} więcej",
      "preview_more": "„{{original}}” jest zastępowany przez „{{replacement}}” w treści, oraz {{nb}} więcej",
      "other_parameters": "Dla tej reguły ustawiono inne parametry – kliknij przycisk edycji, aby uzyskać więcej informacji"
    },
    "content_exclusion": {
      "selectors": "{{nb}} selektor(ów) CSS wykluczonych z tłumaczenia",
      "other_parameters": "Dla tej reguły ustawiono inne parametry – kliknij przycisk edycji, aby uzyskać więcej informacji"
    },
    "url_exclusion": {
      "some_multilingual": "{{nb}} adresów URL jest wykluczonych z tłumaczenia, ale nadal zachowuje przedrostek wielojęzyczny",
      "some": "{{nb}} adresów URL jest całkowicie wykluczonych z tłumaczenia",
      "all_multilingual": "wszystkie adresy URL są wykluczone z tłumaczenia, ale nadal zachowują przedrostek wielojęzyczny",
      "all": "wszystkie adresy URL są całkowicie wykluczone z tłumaczenia",
      "other_parameters": "Dla tej reguły ustawiono inne parametry – kliknij przycisk edycji, aby uzyskać więcej informacji"
    },
    "ignore_inline": {
      "elements": "Cała zawartość w wierszu będzie tłumaczona jako blokowa na stronie",
      "all_elements": "Część treści w wierszu będzie tłumaczona jako blokowa na stronie",
      "other_parameters": "Dla tej reguły ustawiono inne parametry, kliknij przycisk edycji, aby uzyskać więcej informacji"
    },
    "title": "Zarządzanie regułami",
    "description": "Zarządzaj wykluczeniami i zastępowaniami treści tłumaczeń na całej stronie",
    "add": "Dodaj nową regułę",
    "table": {
      "title": "Tytuł",
      "no_data": "Brak reguł",
      "type": "Typ",
      "preview": "Podgląd reguły",
      "action": "Akcja",
      "delete_confirm": "Potwierdź usunięcie reguły",
      "types": {
        "text_ignore": "Ignoruj tekst",
        "text_replace": "Zastąp tekst",
        "content_exclusion": "Wykluczenie zawartości",
        "url_exclusion": "Wykluczenie adresu URL",
        "ignore_inline": "Ignoruj w linii",
        "unknown": "Nieznana reguła"
      }
    },
    "apply_on_content": {
      "static": "Ta zasada będzie stosowana tylko do treści statycznych",
      "dynamic": "Ta zasada będzie stosowana wyłącznie do zawartości dynamicznej"
    }
  },
  "search_translations": {
    "title": "Zarządzanie zapytaniami wyszukiwania",
    "description": "Wyświetl wszystkie tłumaczenia witryny używane w formularzach wyszukiwania (z przetłumaczonego języka na główny język Twojej domeny)",
    "filter_languages": "Filtruj według języków...",
    "filter_original": "Filtruj tekst w języku oryginalnym",
    "filter_translation": "Filtruj według przetłumaczonego tekstu",
    "table": {
      "original": "Oryginał",
      "language": "Język",
      "translation": "Tłumaczenie"
    }
  },
  "subscription": {
    "failure": {
      "tab_title": "Nie udało się zapisać!",
      "title": "Nie udało się zapisać!",
      "subtitle": "Wystąpił błąd podczas przetwarzania subskrypcji.",
      "home": "Wróć do strony głównej",
      "generic": "Wystąpił nieznany błąd po stronie Linguise, skontaktuj się z administratorem!"
    },
    "success": {
      "home": "Zarządzaj tłumaczeniami domeny",
      "message": "Zobowiązujemy się zapewnić Ci najlepsze możliwe doświadczenie tłumaczeniowe. Nasz zespół ekspertów jest dostępny, aby wspierać Cię w przypadku jakichkolwiek pytań lub problemów. Aby rozpocząć, kliknij przycisk poniżej.",
      "subtitle": "Dziękujemy za wybór usługi tłumaczenia Linguise",
      "title": "Subskrypcja aktywowana!",
      "tab_title": "Dziękujemy za subskrypcję!"
    }
  },
  "subscriptions": {
    "success": {
      "tab_title": "Subskrypcja aktywowana!",
      "title": "Subskrypcja aktywowana!",
      "subtitle": "Dziękujemy za wybór usługi tłumaczenia Linguise",
      "message": "Zobowiązujemy się zapewnić Ci najlepsze możliwe doświadczenie tłumaczeniowe. Nasz zespół ekspertów jest dostępny, aby wspierać Cię w przypadku jakichkolwiek pytań lub problemów. Aby rozpocząć, kliknij przycisk poniżej.",
      "home": "Zarządzaj tłumaczeniami domeny"
    },
    "edit": {
      "title": "Zarządzaj subskrypcją"
    },
    "list": {
      "title": "Lista subskrypcji",
      "description": "Lista subskrypcji Twojej domeny"
    },
    "table": {
      "domain": "Domena",
      "plan": "Plan",
      "status": "Status",
      "card": "Karta",
      "usage": "Wykorzystanie",
      "actions": "Akcje",
      "payment_method": "Metoda płatności"
    },
    "usage": {
      "paid": "{{words_used}} / {{words_allowed}} słów",
      "paidOffered": "{{words_used}} / {{words_allowed}} słów\n(W tym {{free_words}} bezpłatnych słów)"
    },
    "popup": {
      "dueToday": "Całość należna dzisiaj",
      "nextPeriod": "Począwszy od {{date}}"
    }
  },
  "topbar": {
    "accounts": {
      "choose": "Wybierz konto"
    }
  },
  "translation": {
    "main": {
      "parent": "Tłumaczenia",
      "edit": "Edytuj tłumaczenie"
    },
    "form": {
      "original": {
        "title": "Oryginał w języku {{language}}"
      },
      "is_inline": "Tego tłumaczenia dokonano z zawartości w linii.",
      "inline_editor": {
        "count_warning": "Liczba obszarów w tekście nie zgadza się z oryginałem ({{current}} z {{expected}}).",
        "restore_original": "Przywróć oryginalny tekst",
        "insert_placeholder": "Wstaw symbol zastępczy",
        "drag": "Przeciągnij, aby zmienić kolejność obszaru",
        "area": "Obszar inline {{index}}",
        "restore": "Przywróć brakujące obszary w tekście"
      },
      "translation": {
        "title": "Tłumaczenie w języku {{language}}",
        "description": "Tłumaczenie, które chcesz nadpisać"
      }
    },
    "copy": {
      "title": "Kopiuj do tłumaczenia ręcznego",
      "label": "Kopiuj do ręcznego"
    },
    "level": {
      "base": {
        "title": "Tłumaczenie bazowe",
        "subtitle": "Automatyczne · tłumaczenie Linguise Cloud",
        "empty": "Brak tłumaczenia bazowego dla tego tekstu.",
        "overridden": "Twój wybór został zapisany, ale zamiast niego wyświetlane jest najnowsze tłumaczenie ulepszone przez AI, ponieważ „Nadpisuj tłumaczenia ręczne i wybrane” jest ustawione na Tak w ustawieniach tłumaczenia AI. Wyłącz to ustawienie, aby użyć swojego wyboru."
      },
      "not_generated": "Nie wygenerowano",
      "none": "Jeszcze nic",
      "ai": {
        "title": "Ulepszone tłumaczenie AI",
        "subtitle": "Automatyczne · Linguise AI",
        "empty_title": "Jeszcze nie wygenerowano dla tego tekstu",
        "empty_description": "Linguise AI tworzy bardziej naturalne tłumaczenia, wykorzystując kontekst Twojej strony i witryny. Aby uzyskać je tutaj:",
        "empty_step_1": "Przejdź do Tłumaczenie AI › Ustawienia i ustaw Włącz tłumaczenie AI na “Tylko reguły”, “Tylko edytor na żywo” lub “Reguły i edytor”.",
        "empty_step_2": "Zastosuj je za pomocą reguły pasującej do tej strony lub włącz strona po stronie w edytorze na żywo.",
        "empty_step_3": "Ulepszone tłumaczenie AI pojawi się tutaj po wygenerowaniu. Zużywa Twoje kredyty AI.",
        "open_settings": "Otwórz ustawienia tłumaczenia AI",
        "open_editor": "Otwórz edytor na żywo",
        "overrides_selection": "Twój wybór został zapisany, ale zamiast niego wyświetlane jest to ulepszone tłumaczenie AI, ponieważ „Nadpisuj tłumaczenia ręczne i wybrane” jest ustawione na Tak w ustawieniach tłumaczenia AI. Wyłącz to ustawienie, aby użyć swojego wyboru.",
        "overrides_version": "Wybrana wersja została zapisana, ale zamiast niej wyświetlana jest najnowsza wersja ulepszona przez AI, ponieważ „Nadpisuj tłumaczenia ręczne i wybrane” jest ustawione na Tak w ustawieniach tłumaczenia AI. Wyłącz to ustawienie, aby użyć wybranej wersji."
      },
      "manual": {
        "title": "Tłumaczenie ręczne",
        "subtitle": "Napisane przez Ciebie · ma priorytet nad tłumaczeniami automatycznymi",
        "empty": "Puste",
        "saved_but_overridden": "Zapisano jako Twój wybór, ale nie jest wyświetlane automatycznie, ponieważ “Nadpisuj tłumaczenia ręczne” jest ustawione na Tak w ustawieniach tłumaczenia AI: ulepszone tłumaczenie AI ma pierwszeństwo, dopóki to ustawienie nie zostanie wyłączone.",
        "ignored": "Nie jest wyświetlane automatycznie, ponieważ “Nadpisuj tłumaczenia ręczne” jest ustawione na Tak w ustawieniach tłumaczenia AI. Wybierz je, aby użyć go dla tego tekstu.",
        "label": "Twoje tłumaczenie",
        "placeholder": "Wpisz własne tłumaczenie...",
        "last_updated": "Ostatnia edycja {{date}}",
        "save_hint": "Zapisanie tłumaczenia ręcznego czyni je aktywnym.",
        "delete": "Usuń tłumaczenie ręczne",
        "delete_confirm": "Potwierdź usunięcie tłumaczenia ręcznego"
      }
    },
    "history": {
      "title": "Ulepszone wersje AI",
      "subtitle": "Każda regeneracja z edytora na żywo jest zachowywana",
      "unknown_model": "Nieznany model",
      "current": "Bieżąca",
      "restore": "Przywróć tę wersję",
      "restore_note": "Przywrócenie ustawia tę wersję jako bieżące ulepszone tłumaczenie AI. Nic nie jest usuwane.",
      "version_of": "Wersja {{current}} z {{total}}",
      "hide": "Ukryj historię ({{total}})",
      "show": "Pokaż historię ({{total}})"
    },
    "choose": {
      "title": "Tłumaczenia na {{language}} · wybierz to, które widzą odwiedzający",
      "current": "Obecnie na Twojej stronie:",
      "priority": "Domyślny priorytet: ręczne › ulepszone AI › bazowe. Twój wybór dotyczy tylko tego tłumaczenia.",
      "reset": "Przywróć domyślny priorytet",
      "reset_title": "Zapomnij wybór dla tego tekstu i ponownie użyj domyślnego priorytetu",
      "resetting": "Przywracanie..."
    }
  },
  "translations": {
    "title": "Zarządzanie tłumaczeniami",
    "description": "Wyświetlaj i edytuj wszystkie tłumaczenia witryny; do tłumaczenia wizualnego użyj Edytora Na Żywo",
    "filter_languages": "Filtruj według języków...",
    "filter_original": "Filtruj tekst w języku oryginalnym",
    "filter_translation": "Filtruj według przetłumaczonego tekstu",
    "table": {
      "original": "Oryginał",
      "language": "Język",
      "action": "Akcja",
      "base": "Bazowe",
      "ai": "Ulepszone AI",
      "manual": "Ręczne"
    },
    "filter_exact": "Dokładne dopasowanie",
    "badge": {
      "active": "Aktywne",
      "overrides_manual": "Nadpisuje ręczne"
    },
    "cell": {
      "none": "brak",
      "not_generated": "nie wygenerowano",
      "ignored": "Zignorowane – reguła AI wygrywa"
    },
    "tabs": {
      "all": "Wszystkie",
      "manual": "Z ręcznym",
      "ai": "Z ulepszonym AI",
      "base": "Tylko bazowe"
    },
    "levels_hint": "Każdy tekst ma do 3 poziomów — ten oznaczony jako Aktywne jest widoczny dla odwiedzających."
  },
  "url": {
    "main": {
      "parent": "Adresy URL",
      "edit": "Edytuj tłumaczenie adresu URL"
    },
    "form": {
      "original": {
        "title": "Oryginał w języku {{language}}"
      },
      "translation": {
        "title": "Tłumaczenie adresu URL w języku {{language}}",
        "description": "Adres URL, który chcesz nadpisać",
        "placeholder": "Nadpisanie tłumaczenia adresu URL",
        "invalid_full": "Próbujesz zmienić na nieprawidłowy format; powinieneś zmieniać tylko slugi/nazwy ścieżek w tłumaczeniu adresu URL",
        "invalid": "Podano nieprawidłowy adres URL/ścieżkę"
      }
    }
  },
  "urls": {
    "title": "Zarządzanie adresami URL",
    "description": "Wyświetlaj i edytuj wszystkie przetłumaczone adresy URL witryny (zaawansowane – uważaj na błędy 404)",
    "filter_languages": "Filtruj według języków...",
    "filter_original": "Filtruj tekst w języku oryginalnym",
    "filter_translation": "Filtruj według przetłumaczonego tekstu",
    "table": {
      "original": "Oryginał",
      "language": "Język",
      "url": "Przetłumaczony adres URL",
      "action": "Akcja",
      "edited": "Oryginalne tłumaczenie zostało edytowane"
    }
  }
}
